RivalIQ.module('landscape.enums', function (enums, App, Backbone, Marionette, $, _) {

    'use strict';

    enums.overLimitErrorTypes = {
        TooManyCompaniesInLandscapeError: {
            id: 3,
            name: 'TooManyCompaniesInLandscapeError'
        }
    };

});
